export class Inventario {
    idInventario: number;
    idTipoInventario: number;
    descripcion: string;
    checked: boolean;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/inventario.ts